import { useQuery } from '@tanstack/react-query';

import getLibrarySections from '@/requests/library/getLibrarySections';

import type { LibrarySection } from '@/types';

/**
 * Single batch fetch of all library sections. Tabs derive from the same
 * response (`section.title`/`section.slug`), so the whole library costs one
 * request. Sections arrive together and in hub order, which also preserves
 * the stable row indices the deeplink scroll relies on.
 */
const useLibrarySectionsQuery = () => {
  return useQuery<LibrarySection[] | null>({
    queryKey: ['library-sections'],
    queryFn: getLibrarySections,
    // Cache for 5 minutes to prevent duplicate requests when remounting
    staleTime: 5 * 60 * 1000,
    // Keep in cache for 10 minutes
    gcTime: 10 * 60 * 1000,
  });
};

export default useLibrarySectionsQuery;
